export default __webpack_public_path__ + "static/media/information--street-name-one-line--g1.94494101.png";